import { render, staticRenderFns } from "./MerchandisingNotifications.vue?vue&type=template&id=7b61ed7e&"
import script from "./MerchandisingNotifications.vue?vue&type=script&lang=js&"
export * from "./MerchandisingNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports